import React, { Component } from "react";

/**
 * 計時器。
 *
 * startingSeconds 是續考用的：被鎖住解鎖回來時要接著剩下的時間跑，
 * 不是重新給滿。沒給就照原本的 startingMin 從頭算。
 *
 * onTick 每秒回報剩餘秒數，讓上層可以連同答案一起存進度。
 */
class Timer extends Component {
  constructor(props) {
    super(props);
    const total =
      props.startingSeconds !== undefined && props.startingSeconds !== null
        ? Math.max(0, Math.round(props.startingSeconds))
        : props.startingMin * 60;
    this.state = {
      hideTime: false,
      minutes: Math.floor(total / 60),
      minutesPlueOne: Math.ceil(total / 60),
      seconds: 60,
      secondsRemaining: total,
    };
  }

  componentDidMount() {
    this.timer = setInterval(this.tick, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  tick = () => {
    const min = Math.floor(this.state.secondsRemaining / 60);
    const minPlusOne = Math.ceil(this.state.secondsRemaining / 60);
    const sec = this.state.secondsRemaining - min * 60;

    this.setState({ minutes: min, seconds: sec, minutesPlueOne: minPlusOne });

    if (sec < 10) {
      this.setState({ seconds: `0${sec}` });
    }

    if (min < 10) {
      this.setState({ minutes: `0${min}` });
    }

    this.setState({ secondsRemaining: this.state.secondsRemaining - 1 }, () => {
      if (this.props.onTick) {
        this.props.onTick(this.state.secondsRemaining);
      }
      // 用 <= 而不是 ===：續考可能從 0 秒接手（存檔剛好落在歸零那一刻），
      // 寫死等於 0 的話會直接跳過結束條件，計時器一路跑成負數
      if (this.state.secondsRemaining <= 0) {
        this.props.forceEndTest();
      }
    });
  };

  renderTime() {
    if (this.state.hideTime) {
      return <span>Click to show time</span>;
    } else {
      return (
        <span>
          <span className="show-hover">
            <span className="font-big">
              {this.state.minutes}:{this.state.seconds}{" "}
            </span>
            left
          </span>
          <span className="hide-hover">
            <span className="font-big">{this.state.minutesPlueOne} </span>
            minutes left
          </span>
        </span>
      );
    }
  }

  render() {
    const flash =
      ((this.state.secondsRemaining <= 600 &&
        this.state.secondsRemaining >= 596) ||
        (this.state.secondsRemaining <= 300 &&
          this.state.secondsRemaining >= 296)) &&
      !this.state.hideTime
        ? true
        : false;

    return (
      <div className="col col-12 col-md-2 timer">
        <img className="height-control" src="/img/Clock.svg" alt="" />
        <span
          onClick={() => this.setState({ hideTime: !this.state.hideTime })}
          className={`timer-container ${flash ? "flash" : ""} ${
            this.state.secondsRemaining <= 300 && !this.state.hideTime
              ? "red"
              : ""
          }`}
        >
          {this.renderTime()}
        </span>
      </div>
    );
  }
}

export default Timer;
